import { render } from "./Catalogue.vue?vue&type=template&id=5c970e55&scoped=true&bindings={}"
import script from "./Catalogue.vue?vue&type=script&lang=ts"
export * from "./Catalogue.vue?vue&type=script&lang=ts"

import "./Catalogue.vue?vue&type=style&index=0&id=5c970e55&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5c970e55"

export default script